import { useTranslation, t } from '../../../shared/i18n';
import React from 'react';
import { Space, Typography } from 'antd';
import ProductPlans from '../../components/ProductPlans';

const { Text } = Typography;

// 2026-10-07：套餐/价格/配额改为读取 /products（products.features 即后端执行配额），不再硬编码。
const CACHE_LEVEL = { basic: '基础', advanced: '高级', full: '全功能' };
const retention = (v) => {
    const m = String(v).match(/^(\d+)\s*days?$/i);
    return m ? t('{{value}} days', { value: m[1] }) : String(v);
};

const FEATURES = [
    { key: 'shared_resources_limit', label: '可绑定域名', unit: '个' },
    // enforcedKey:后端实际执行的 resource_features 键(展示与执行同源)
    { key: 'cdn_hostnames_per_domain_limit', enforcedKey: 'cdn_hostnames_limit', label: '每域名主机名', unit: '个' },
    { key: 'cdn_traffic_limit_gb', label: '月流量', unit: 'GB' },
    { key: 'cdn_rules_per_domain_limit', enforcedKey: 'cdn_rules_limit', label: '每域名页面规则', unit: '条' },
    { key: 'cdn_cache_level', label: '缓存能力', format: (v) => t(CACHE_LEVEL[v] || v) },
    { key: 'cdn_log_retention', label: '日志保留', format: retention },
    { key: 'cdn_cache_purge', label: '缓存刷新' },
    { key: 'cdn_https_force', label: '强制 HTTPS' },
    { key: 'cdn_custom_ssl', label: '自定义 SSL 证书' },
    { key: 'cdn_waf_enabled', label: 'WAF 防火墙' },
    { key: 'cdn_websocket_enabled', label: 'WebSocket' },
    { key: 'cdn_custom_server_header', label: '自定义 Server 头' },
];


const CdnPlans = () => {
    const { t } = useTranslation();
    return (
        <>
            <ProductPlans
                productType="cdn"
                resourceParam="domain_id"
                resourceLabel={t('Domains')}
                resourceListPath="/cdn/domains"
                title={t('CDN plans')}
                subtitle={t('Choose a plan on the domain; plans that cover multiple domains are managed on the primary domain')}
                featureDefs={FEATURES.map(feature => ({ ...feature, label: t(feature.label), ...(feature.unit ? { unit: t(feature.unit) } : {}) }))}
                notes={
                    <Space direction="vertical" size={4}>
                        <Text><Text strong>{t('Monthly traffic:')}</Text>{t('Edge traffic included per billing cycle')}</Text>
                        <Text><Text strong>{t('Page rules:')}</Text>{t('Number of rules that customize caching, redirects, request headers, and other behavior by path')}</Text>
                        <Text><Text strong>{t('WAF firewall:')}</Text>{t('Managed rulesets + custom firewall rules')}</Text>
                    </Space>
                }
            />
        </>
    );
};

export default CdnPlans;
